export const apiRoute = process.env.REACT_APP_API_BASE_URL || 'https://api.concours.eni.mg';
// export const apiRoute = "http://localhost:3000";
export const apiRouteFile = `${apiRoute}/upload`;
export const apiRouteFileConvocation = `${apiRoute}/pdf/convocation`;
export const token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJhaW5ha3VtQGdtYWlsLmNvbSIsInJvbGUiOiJzZWNyZXRhcnkiLCJmaXJzdG5hbWUiOiJIYWphIiwibGFzdG5hbWUiOiJBaW5hIiwiaWF0IjoxNjYyMzYwNjYxLCJleHAiOjE2NjI0NDcwNjF9.SGycokDXvjOYMIB2WYxf-Jmlo5J6PtwKg7Mp4zg2MJc';
